/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     Nav Menu
//   Details:    Nav Menu
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 101885 26/06/19 AJ  M01  Added Links
// 102715 15/08/19 JC  M02  Added Contacts
// 104759 21/11/19 JC  M03  Whole menu now soft-coded
// 103782 10/12/19 JC  M04  Added MyTraining
// 106380 30/04/20 JC  M05  Added authentication, ManagerPortal / PortalRedirect page
// 103839 13/05/20 JC  M06  Added TeamPortal redirect
// 110638 09/02/21 JC       Now uses material-ui
// 115432 17/02/22 JC  M07JC    Handle logo sizing better
// WI2583 24/01/23 JC  M08JC  Fix needsSmallMenu prop type
//-------------------------------------------------------
*/
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppBar, Container, Divider, Drawer, MenuItem, Toolbar } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
//import './css/NavMenu.css';
//import { isNullOrndefined } from 'util';

const useStyles = makeStyles((theme) =>
  createStyles({
    logo: {
      width: 'auto', // M07JC was 100%
      height: 'auto', // M07JC was 100%
      maxWidth: '230px',
      maxHeight: '72px', // M07JC match paperToolbar maxHeight
    },
    companyNameLarge: {
      color: 'white',
      fontSize: '20px',
      paddingLeft: theme.spacing(2.5),
    },
    companyNameSmall: {
      color: 'white',
      fontSize: '14px',
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
    },
    menuItem: {
      color: 'white',
      textTransform: 'uppercase',
      fontSize: '14px',
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      paddingRight: theme.spacing(2),
      '&:hover': {
        background: '#88B4DB',
        color: 'black',
      },
    },
    activeMenuItem: {
      background: '#88B4DB',
      color: 'black',
      textTransform: 'uppercase',
      fontSize: '14px',
      paddingLeft: theme.spacing(2),
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      paddingRight: theme.spacing(2),
      '&:hover': {
        background: '#88B4DB',
        color: 'black',
      },
    },
    drawerPaperSmall: {
      background: '#4C565B;',
      height: '100%',
    },
    drawerPaperLarge: {
      background: '#4C565B;',
      width: '25%',
    },
    appBarSmall: {
      flexGrow: 1,
      background: '#4C565B;',
      zIndex: theme.zIndex.drawer + 1, // this pushes the appbar above the paper
    },
    appBarLarge: {
      flexGrow: 1,
      background: '#4C565B;',
      zIndex: theme.zIndex.drawer + 1, // this pushes the appbar above the paper
    },
    divider: {
      background: 'black',
    },
    paperToolbar: {
      minHeight: '72px', // overridden from normal 64px to better fit page
    }
  }),
);

const NavMenu = (props) => {

  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const handleDrawerBurderClick = () => {
    setOpenDrawer(!openDrawer);
  };
  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const renderMenuItems = () => {
    return (
      <>

        {/* M03 notices, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epNoticesEnabled
          ?
          <LinkContainer to={'/notices'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              Notices
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 documents, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epDocumentsEnabled
          ?
          <LinkContainer to={'/documents'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              Documents
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 my pay, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epMyPayEnabled
          ?
          <LinkContainer to={'/mypay'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              My Pay
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 my details, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epMyDetailsEnabled
          ?
          <LinkContainer to={'/mydetails'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              My Details
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 my plan, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epMyPlanEnabled
          ?
          <LinkContainer to={'/myplan'} className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              My Plan
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 my requests, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epMyRequestsEnabled
          ?
          <LinkContainer to={'/myrequests'} className={classes.menuItem} activeClassName={classes.activeMenuItem} >
            <MenuItem onClick={handleDrawerBurderClick} >
              My Requests
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M04 my training, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epMyTrainingEnabled
          ?
          <LinkContainer to={'/mytraining'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem}>
            <MenuItem onClick={handleDrawerBurderClick} >
              My training
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 contacts, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epContactsEnabled
          ?
          <LinkContainer to={'/contacts'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem}>
            <MenuItem onClick={handleDrawerBurderClick} >
              Contacts
              </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M03 change password, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epChangePasswordEnabled
          ?
          <LinkContainer to={'/changepassword'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem}>
            <MenuItem onClick={handleDrawerBurderClick} >
              Change Password
					      </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M05 manager portal, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epManagerPortalEnabled &&
          props.authentication && props.authentication.user && props.authentication.user.isEnabledForMP
          ?
          <LinkContainer to={'/portalredirect/2'} className={classes.menuItem} activeClassName={classes.activeMenuItem}>
            <MenuItem onClick={handleDrawerBurderClick} >
              Manager Portal
					    </MenuItem>
          </LinkContainer>
          : []
        }

        {/* M06 team portal, if enabled */}
        {props.systemControl.configuration && props.systemControl.configuration.epTeamPortalEnabled &&
          props.authentication && props.authentication.user && props.authentication.user.isEnabledForTP
          ?
          <LinkContainer to={'/portalredirect/3'} className={classes.menuItem} activeClassName={classes.activeMenuItem}>
            <MenuItem onClick={handleDrawerBurderClick} >
              Team Portal
					    </MenuItem>
          </LinkContainer>
          : []
            }

            {/* M07AJ Third Party Return Point, if enabled */}
            {props.authentication.user.thirdPartyMenuTitle && props.authentication.user.thirdPartyMenuTitle.length > 0
                ?
                /*This is deliberate! We need a link container so the menu items render correctly UI wise, we have to enter a 'to', or else the nav bar errors,
                and because it's the home page we set the active menu item class to the same as the non-active so it's not highlighted*/

                <LinkContainer to={'/'} className={classes.menuItem} activeClassName={classes.menuItem}>
                    <MenuItem onClick={(event) => {
                        /*Open the url in a new tab*/
                        window.open(props.authentication.user.thirdPartyMenuURL, '_blank');
                        /*This will force the focus away from the link item*/
                        document.activeElement.blur();
                        /*Close drawer if necessary*/
                        handleDrawerBurderClick();
                    }} >
                        {props.authentication.user.thirdPartyMenuTitle}
                    </MenuItem>
                </LinkContainer>
                : []
            }

        {props.systemControl.configuration && props.systemControl.configuration.epLink1Enabled &&
          props.systemControl.configuration.epLink1Title && props.systemControl.configuration.epLink1Title.length > 0  /*M03*/
          ?
          /*This is deliberate! We need a link container so the menu items render correctly UI wise, we have to enter a 'to', or else the nav bar errors,
           and because it's the home page we set the active menu item class to the same as the non-active so it's not highlighted*/
          <LinkContainer to={'/'} className={classes.menuItem} activeClassName={classes.menuItem}>
            <MenuItem onClick={(event) => {
              /*Open the url in a new tab*/
              window.open(props.systemControl.configuration.epLink1URL, '_blank'); /*M03*/
              /*This will force the focus away from the link item*/
              document.activeElement.blur();
              /*Close drawer if necessary*/
              handleDrawerBurderClick();
            }} >
              {props.systemControl.configuration.epLink1Title} {/*M03*/}
              </MenuItem>
          </LinkContainer>
          : []
        }

        {props.systemControl.configuration && props.systemControl.configuration.epLink2Enabled &&
          props.systemControl.configuration.epLink2Title && props.systemControl.configuration.epLink2Title.length > 0  /*M03*/
          ?
          /*This is deliberate! We need a link container so the menu items render correctly UI wise, we have to enter a 'to', or else the nav bar errors,
          and because it's the home page we set the active menu item class to the same as the non-active so it's not highlighted*/
          <LinkContainer to={'/'} className={classes.menuItem} activeClassName={classes.menuItem}>
            <MenuItem onClick={(event) => {
              /*Open the url in a new tab*/
              window.open(props.systemControl.configuration.epLink2URL, '_blank'); /*M03*/
              /*This will force the focus away from the link item*/
              document.activeElement.blur();
              /*Close drawer if necessary*/
              handleDrawerBurderClick();
            }} >
              {props.systemControl.configuration.epLink2Title}  {/*M03*/}
            </MenuItem>
          </LinkContainer>
          : []
        }

        <LinkContainer to={'/logout'} exact className={classes.menuItem} activeClassName={classes.activeMenuItem} >
          <MenuItem onClick={handleDrawerBurderClick}>
            Log Out
            </MenuItem>
        </LinkContainer>
      </>
    );
  };

  const renderSmallMenu = () => {
    return (
      <div className={classes.root}>
        <AppBar className={classes.appBarSmall}>
          <Container disableGutters maxWidth={false}>
            <Toolbar>
              <Col xs={10}>
                <Link to={'/'}><img className={classes.logo} src="header-logo.png" alt="Employee Portal Logo" onClick={handleDrawerBurderClick} /></Link>
              </Col>
              <Col xs={2}>
                <div className="float-right">
                  <button type="button" className="btn btn-default" onClick={handleDrawerBurderClick}><FontAwesomeIcon icon="bars" /></button>
                </div>
              </Col>
            </Toolbar>
          </Container>
        </AppBar>
        <Drawer
          variant="persistent"
          anchor="top"
          open={openDrawer}
          onClose={handleDrawerClose}
          classes={{
            paper: classes.drawerPaperSmall,
          }}
        >
          {/* below toolbar is what actually pushes the menu items down */}
          <Toolbar className={classes.paperToolbar} />
          {/* company name */}
          {props.systemControl.configuration && props.systemControl.configuration.companyName ?
            <span className={classes.companyNameSmall}>{props.systemControl.configuration && props.systemControl.configuration.companyName} Employee Portal</span> : []}
          <Divider className={classes.divider} />

          {renderMenuItems()}
        </Drawer>
      </div>
    );
  };

  const renderLargeMenu = () => {
    return (
      <div className={classes.root}>
        <AppBar className={classes.appBarLarge} position="fixed">
                <Container disableGutters maxWidth={false}> {/*M08JC was true */}
            <Toolbar>
              <Link to={'/'}><img className={classes.logo} src="header-logo.png" alt="Employee Portal Logo" /></Link>
              {props.systemControl.configuration && props.systemControl.configuration.companyName ?
                <span className={classes.companyNameLarge}>{props.systemControl.configuration && props.systemControl.configuration.companyName} Employee Portal</span> : []}
            </Toolbar>
          </Container>
        </AppBar>
        <Drawer
          variant="permanent"
          anchor="left"
          open={openDrawer}
          onClose={handleDrawerClose}
          classes={{
            paper: classes.drawerPaperLarge,
          }}
        >
          {/* below toolbar is what actually pushes the menu items down */}
          <Toolbar className={classes.paperToolbar} />
          {renderMenuItems()}
        </Drawer>
      </div>
    );
  };



  return (
    <>
      {props.needsSmallMenu ?
        renderSmallMenu() :
        renderLargeMenu()}
    </>
  );
};
NavMenu.propTypes = {
    //M03 just pass down the whole of system control
    //companyName: PropTypes.string.isRequired,
    //link1Title: PropTypes.string.isRequired, //M01
    //link1URL: PropTypes.string.isRequired, //M01
    //link2Title: PropTypes.string.isRequired, //M01
    //link2URL: PropTypes.string.isRequired //M01
    systemControl: PropTypes.object.isRequired, //M04
    authentication: PropTypes.object.isRequired, //M05
    needsSmallMenu: PropTypes.bool //M08JC
};

export default NavMenu;